<template>
  <div class="">
    <div class="flex h-.5 fixed top-0 z-40 inset-x-0">
      <div class="w-1/4 bg-cardstock-blue-500"></div>
      <div class="w-1/4 bg-cardstock-green-500"></div>
      <div class="w-1/4 bg-cardstock-yellow-500"></div>
      <div class="w-1/4 bg-cardstock-red-500"></div>
    </div>
    <div class="flex bg-white min-h-screen-mobile-safe h-screen-mobile-safe">
    <!-- Off-canvas menu for mobile -->
    <div class="md:hidden">
      <Transition
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div @click="sidebarOpen = false" v-show="sidebarOpen" class="fixed inset-0 transition-opacity ease-linear duration-200 z-40">
          <div class="absolute inset-0 bg-cool-gray-600 opacity-75"></div>
        </div>
      </Transition>
      <Transition>
      <div v-show="sidebarOpen" class="fixed inset-0 flex z-40 transition duration-200">
        <Transition
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div v-show="sidebarOpen" class="flex-1 flex flex-col max-w-xs w-full bg-white transform ease-in-out duration-200">
            <div v-show="sidebarOpen" class="absolute top-0 right-0 -mr-14 p-1">
              <button @click="sidebarOpen = false" class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-cool-gray-600" aria-label="Close sidebar">
                <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto" v-body-scroll-lock="sidebarOpen">
              <div class="flex-shrink-0 flex items-center px-4">
                <img class="h-8 w-auto" src="/images/Cardstock_Logo_Color.svg" alt="Workflow" />
              </div>
              <nav class="mt-5 px-2">
                <router-link
                  :to="{name: 'conversations'}"
                  class="group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-cool-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#comment"></use>
                  </svg>
                  Conversations
                </router-link>
                <router-link
                  v-if="false"
                  :to="{name: 'calls'}"
                  class="mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#phone"></use>
                  </svg>
                  Calls
                </router-link>
                <router-link
                  :to="{name: 'blastNew'}"
                  class="mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#bullhorn"></use>
                  </svg>
                  Blasts
                </router-link>
                <router-link
                  :to="{name: 'students'}"
                  class="mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#image"></use>
                  </svg>
                  Students & Classes
                </router-link>
                <router-link
                  :to="{name: 'team'}"
                  class="mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#backpack"></use>
                  </svg>
                  Settings
                </router-link>
                <router-link
                  :to="{name: 'search'}"
                  class="mt-1 group flex items-center px-2 py-2 text-base leading-6 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
                  exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
                  >
                  <svg class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#search"></use>
                  </svg>
                  Search
                </router-link>
              </nav>
            </div>
          </div>
        </Transition>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
      </Transition>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:block md:flex-shrink-0 border-r border-gray-200 bg-gray-100">
      <div class="w-64 sticky top-0">
        <div class="h-0 flex-1 flex flex-col pt-5 pb-4">
          <div class="flex items-center flex-shrink-0 px-4">
            <img class="mr-3 h-6 w-6" src="/images/Cardstock_Logo_Color.svg" alt="Cardstock Logo" />
            <img class="h-4 w-auto" src="/images/Cardstock_Wordmark_Color.svg" alt="Cardstock Wordmark" />
          </div>
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <nav class="mt-8 flex-1 px-2">

            <!-- Desktop: Current User Button and Dropdown -->
            <Toggle  v-slot="{ toggle, didToggle, didToggleOff }">
              <div class="mb-5" v-click-outside="didToggleOff">
                <button type="button" class="shadow group w-full rounded-md px-3.5 py-2 text-sm leading-5 font-medium text-gray-700 bg-gray-50 hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 max-w-full text-left overflow-x-hidden" id="options-menu" aria-haspopup="true" aria-expanded="true" @click="didToggle">
                  <div class="flex w-full justify-between items-center">
                    <div class="flex items-center justify-between space-x-3 w-full">
                      <div class="flex-1 w-0 flex-grow">
                        <h2 class="text-gray-900 text-sm leading-5 font-medium truncate">{{currentUser.email}}</h2>
                        <!-- <p class="text-gray-500 text-xs leading-5 truncate">{{currentUser.email}}</p> -->
                        <p class="text-gray-500 text-xs leading-5 truncate">{{formattedTPN}}</p>
                      </div>
                    </div>
                    <svg class="h-5 w-5 text-gray-400 group-hover:text-gray-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </button>

                <Transition
                  enter-active-class="transition ease-out duration-100 transform"
                  enter-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75 transform"
                  leave-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95"
                >
                  <div @click="didToggle" class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg" v-show="toggle">
                    <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <div class="py-1">
                        <router-link :to="{name: 'settings'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Settings</router-link>
                      </div>
                      <div class="border-t border-gray-100"></div>
                      <div class="py-1">
                        <router-link :to="{name: 'teams'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">View my other Accounts</router-link>
                      </div>
                      <div class="py-1">
                        <router-link :to="{name: 'logout'}" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Logout</router-link>
                      </div>
                    </div>
                  </div>
                </Transition>

              </div>
            </Toggle>  <!-- END Desktop: Current User Button and Dropdown -->

            <div class="space-y-1">
              <router-link
                v-for="item in sidebarItems" :key="item.name"
                :to="item.link"
                class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition ease-in-out duration-150"
                exact-active-class="text-gray-900 bg-gray-200 hover:bg-gray-200"
                >
                <svg class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                  <use :href="item.icon"></use>
                </svg>
                {{item.name}}
              </router-link>
            </div>

            <div class="mt-8" v-if="false">
              <h3 class="px-3 text-xs leading-4 font-semibold text-gray-500 uppercase tracking-wider">
                Resources & Learning
              </h3>
              <div class="mt-1">
                <a href="#" class="group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                  <span class="truncate">
                    Guide to Cardstock
                  </span>
                </a>
                <a href="#" class="mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                  <span class="truncate">
                    What's New
                  </span>
                </a>
                <a href="#" class="mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                  <span class="truncate">
                    Get Assistance
                  </span>
                </a>
              </div>
            </div>

          </nav>
        </div>
      </div>
    </div>
        <div class="flex flex-col w-0 flex-1">
          <Toggle>
            <div class="flex flex-col border-b sm:border-none sticky top-0 bg-white z-20" slot-scope="{toggle, didToggleOn, didToggleOff, didToggle}">
              <div class="md:hidden p-1 sm:p-3 flex justify-between items-center">
                <button @click.stop="sidebarOpen = true" class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150" aria-label="Open sidebar">
                  <svg class="h-6 w-6" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/regular.svg#bars"></use>
                  </svg>
                </button>
                <portal-target name="mobile-header" slim :slot-props="{didToggle: didToggle, toggle: toggle}"/>
                <div class="flex-shrink-0 w-12">
                    <!-- To offset hamburger in Flex -->
                    <portal-target name="mobile-dropdown"/>
                </div>
              </div>
              <Transition
                  enter-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-class="opacity-100"
                  leave-to-class="opacity-0">
                <div class="sm:hidden transition ease-in-out duration-300 p-1 sm:p-3 flex justify-between items-center" v-show="toggle">
                  <portal-target name="mobile-extras" slim/>
                </div>
              </Transition>
            </div>
          </Toggle>

          <router-view :currentUser="currentUser" :onlyUnread="false" />
        </div>
  </div>
  </div>
</template>

<script>
import _get                           from 'lodash-es/get'
import vhCheck                        from 'vh-check'
import { preloadMany }                from '@/preloader'
import CurrentTeacherPhoneNumberQuery from '@/queries/CurrentTeacherPhoneNumber.gql'

import Toggle                         from '@/components/Toggle.js'

const preloadQueries = (to) => {
  return [
    {
      query: CurrentTeacherPhoneNumberQuery,
      queryName: 'currentTeacherPhoneNumber',
      variables: {
        teamId: to.params.teamId
      },
      fetchPolicy: 'cache-first'
    },
  ]
}

export default {
  components: {
    Toggle
  },

  props: ['currentUser', 'teamId'],

  data: function () {
    return {
      sidebarOpen: false,
      vhCheck: {
        unbind: () => {}
      },
      sidebarItems: [
        {
          name: 'Conversations',
          icon: '/images/regular.svg#comment',
          link: {name: 'conversations'}
        },
        // {
        //   name: 'Calls',
        //   icon: '/images/regular.svg#phone',
        //   link: {name: 'calls'}
        // },
        {
          name: 'Blasts',
          icon: '/images/regular.svg#bullhorn',
          link: {name: 'blastNew'}
        },
        {
          name: 'Students & Classes',
          icon: '/images/regular.svg#chalkboard-teacher',
          link: {name: 'students'}
        },
        {
          name: 'School Settings',
          icon: '/images/regular.svg#bus-school',
          link: {name: 'team'}
        },
        {
          name: 'Search',
          icon: '/images/regular.svg#search',
          link: {name: 'search'}
        },
      ]
    }
  },

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next,
      mountedVm: this
    })
  },

  computed: {
    currentUserDisplay() {
      return _get(this.currentUser, 'first') + ' ' + _get(this.currentUser, 'last')
    },

    formattedTPN() {
      return _get(this.currentTeacherPhoneNumber, 'formattedNumber') || 'No Cardstock number'
    }
  },

  mounted() {
    this.vhCheck = vhCheck()
  },

  destroyed() {
    this.vhCheck.unbind()
  },

  beforeRouteUpdate(to, from, next) {
    this.sidebarOpen = false
    next()
  },

  methods: {
    preloadFailed(event) {
      this.$emit('preload-error', event)
    }
  },

  apollo: {
    currentTeacherPhoneNumber: {
      query: CurrentTeacherPhoneNumberQuery,
      variables() {
        return { teamId: this.teamId }
      },
      fetchPolicy: 'cache-first'
    }
  }
}
</script>
